import React from "react";
import Chart from "react-apexcharts";

function PerformanceChart({ data, metric }) {
    data = data ?? [];
    if (!data || data.length == 0) {
        return null;
    }

    data = data.sort((a, b) => new Date(a.date) - new Date(b.date));

    const categories = Array.from(new Set(data.map((a) => a.date)));
    const unique_players = Array.from(new Set(data.map((a) => a.player_id)));
    const series = [];
    for (let pid of unique_players) {
        series.push({
            name: data.find((a) => a.player_id === pid)?.player_name,
            data: categories.map((d) => {
                const game = data.find(
                    (f) => f.player_id === pid && f.date === d
                );
                return game?.[metric] ?? 0;
            }),
        });
    }

    return (
        <>
            {data.length > 0 ? (
                <Chart
                    options={{
                        xaxis: { categories },
                        stroke: { curve: "smooth", width: 3 },
                    }}
                    series={series}
                    type="line"
                    height={400}
                />
            ) : (
                "No data available"
            )}
        </>
    );
}

export default PerformanceChart;
